import React, { useRef, useState } from "react"
import { useMsal } from "@azure/msal-react";

import { Box } from "@mui/material";  
import{ type Treshold} from "./rheoadviseConfig";
import { Skid } from "../AvailableSkids/skidsWithConfigProvider";
import { authenticatedFetch} from '../../Helper/Fetch/fetch';
import { loginRequest, protectedResources } from "../../authConfig";
import { getRheoServerUrl } from "../../Config/config";

interface TresholdProps{
    treshold: Treshold,
    skid:string,
    skidsWithConfig: Map<string, Skid>,
    deleteHandler: (treshold:Treshold) => void
}



function TresholdConfig(props:TresholdProps){
    const { instance, inProgress,accounts } = useMsal();
    const request = {scopes: protectedResources.whoami.scopes,account: accounts[0]}
    const nanoSecondsToMinutes = (ns:number) => {
        return ns / 60000000000
    }
    const { treshold, skid, skidsWithConfig, deleteHandler } = props
    const [type, setType] = useState<string>(treshold?.Type?treshold.Type:'')
    const [value, setValue] = useState<number>(treshold?.Value?treshold.Value:0)
    const [period, setPeriod] = useState<number>(nanoSecondsToMinutes(treshold?.Period?treshold.Period:0))
    const [ratio, setRatio] = useState<number>(treshold?.Ratio?treshold.Ratio:0)
    const simpleInputStyle = {maxWidth: '50px', background:'#0A1929', color:'whitesmoke', border:'1px solid #1E2A3B', borderRadius:2, padding:2}

    function DeleteTreshold(treshold:Treshold){
    console.log('deleting treshold')
    const params =  new URLSearchParams({
        'Action':'deleteTreshold',
        'Id':treshold.Id,
        'Skid':skidsWithConfig.get(skid).name,
        'Tag':treshold.Tag,
    })
     const urlBase = getRheoServerUrl()
     const url = urlBase+'/rheoadvise'
     authenticatedFetch(request, instance, params, url).
     then((res)=>{
         if(res.ok){
                deleteHandler(treshold)
             alert('Treshold deleted successfully:'+res.statusText)
         }else{
             alert('Error deleting treshold:'+res.statusText)
         }
     })
    }

    function UpdateTreshold(treshold:Treshold, updates: Partial<Treshold>){
    console.log('updating treshold')
    const params =  new URLSearchParams({
        'Action':'updateTreshold',
        'Id':treshold.Id,
        'Type': updates.Type? updates.Type : treshold.Type,
        'Value': updates.Value? updates.Value.toString() : treshold.Value.toString(),
        'Period': updates.Period? updates.Period.toString() : treshold.Period.toString(),
        'Ratio': updates.Ratio? updates.Ratio.toString() : treshold.Ratio.toString(),
        'Skid':skidsWithConfig.get(skid).name,
        'Tag':treshold.Tag
    })
     const urlBase = getRheoServerUrl()
     const url = urlBase+'/rheoadvise'
     authenticatedFetch(request, instance, params, url).
     then((res)=>{
         if(res.ok){
             alert('Treshold updated successfully:'+res.statusText)
         }else{
             alert('Error updating treshold:'+res.statusText)
         }
     })
    }
    if (skidsWithConfig.get(skid).supervisor === true){
        return(
            <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-between', columnGap:5, background:'#0A1929', alignItems:'center' , p:1, borderRadius:2}}>
                <p style={{color:'whitesmoke'}} color="white" >Tag: {treshold?.Tag}</p>
                <select style={{maxWidth: '100px'}} value={type} onChange={(e)=>setType(e.target.value)}>
                    <option value="delta">delta</option>
                    <option value="percentage">percentage</option>
                </select>
                <input style={simpleInputStyle} type='number' placeholder="Value" value={value} onChange={(e)=>setValue(parseFloat(e.target.value) || 0)}/>
                <input style={simpleInputStyle} type='number' placeholder="Period" value={period} onChange={(e)=>setPeriod(parseFloat(e.target.value) || 0)}/> <p style={{color:'whitesmoke'}}>minutes</p>
                <input style={simpleInputStyle} type='number' placeholder="Ratio" value={ratio} onChange={(e)=>setRatio(parseFloat(e.target.value) || 0)}/> <p style={{color:'whitesmoke'}}>%</p>
                <button onClick={()=>DeleteTreshold(treshold)}>Delete</button>
                <button onClick={()=>UpdateTreshold(treshold, { Type:type, Value:value, Period:period, Ratio:ratio })}>Update</button>
            </Box>
        )
    }
    return(
        <Box sx={{display:'flex', flexDirection:'row', justifyContent:'space-between', columnGap:5, background:'#0A1929', alignItems:'center' , p:1, borderRadius:2}}>
            <p style={{color:'whitesmoke'}} color="white" >Tag: {treshold?.Tag}</p>
            <p style={{color:'whitesmoke'}} color="white">Type:{type}</p>
            <p style={{color:'whitesmoke'}} color="white">Value: {value}</p>
            <p style={{color:'whitesmoke'}} color="white">Period: {period} minutes</p>
            <p style={{color:'whitesmoke'}} color="white">Ratio: {ratio} %</p>
        </Box>
    )
}
export default TresholdConfig